import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { privateRoutes, publicRoutes } from "./routes";
import Layout from "./componentes/Layout";
import PrivateRoute from "./routes/PrivateRoute";
import { EstiloProvider } from "./context/EstiloContext";

function App() {
  return (
    <EstiloProvider>
      <BrowserRouter>
        <Suspense fallback={<div>Cargando...</div>}>
          <Routes>
            {/* Rutas públicas */}
            {publicRoutes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}

            {/* Rutas privadas */}
            <Route path="/" element={<Layout />}>
              {privateRoutes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={<PrivateRoute component={route.component} />}
                />
              ))}
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </EstiloProvider>
  );
}

export default App;
